import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { CallersQueryVariables } from '@/gql/graphql';

// Fragments
import './fragments/callerFragment';

export const fetchCustomers = async ({ partnerId, affiliateId, isActive, pagination }: CallersQueryVariables) => {
  const response = await queryExecute({
    variables: {
      partnerId,
      affiliateId,
      isActive,
      pagination,
    },
    fetchPolicy: 'no-cache',
    query: graphql(`
      query Callers($pagination: PaginationInputType, $isActive: Boolean, $partnerId: Float, $affiliateId: Float) {
        callers(pagination: $pagination, isActive: $isActive, partnerId: $partnerId, affiliateId: $affiliateId) {
          count
          rows {
            ...CallerFragment
          }
        }
      }
    `),
  });

  return response.data.callers!;
};
